export const PlayerHome = (player) => {
  return <div className="player-home"></div>;
};
